/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Send_LinkInputs */

const en_password_reset_send_link = /** @type {(inputs: Password_Reset_Send_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send reset link`)
};

const es_password_reset_send_link = /** @type {(inputs: Password_Reset_Send_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar enlace`)
};

/**
* | output |
* | --- |
* | "Send reset link" |
*
* @param {Password_Reset_Send_LinkInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_send_link = /** @type {((inputs?: Password_Reset_Send_LinkInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Send_LinkInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_send_link(inputs)
	return en_password_reset_send_link(inputs)
});